import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { storage } from "@/firebase";

export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
  "image/avif",
];

// Geeft een Nederlandse foutmelding terug, of null als het bestand in orde is.
export function validateImage(file) {
  if (!file) {
    return "Geen bestand gekozen.";
  }
  if (!ALLOWED_TYPES.includes(file.type)) {
    return "Dit bestandstype kan niet gebruikt worden. Kies een JPG, PNG, WEBP of GIF.";
  }
  if (file.size > MAX_IMAGE_BYTES) {
    return `De afbeelding is te groot (${formatBytes(
      file.size
    )}). Maximaal ${formatBytes(MAX_IMAGE_BYTES)}.`;
  }
  return null;
}

export function formatBytes(bytes) {
  if (bytes < 1024 * 1024) {
    return `${Math.round(bytes / 1024)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

// Uploadt een afbeelding en geeft de publieke download-url terug.
// onProgress krijgt een percentage (0-100) zodat de knop een voortgangsbalk kan tonen.
export function uploadImage(file, { folder = "nieuws", onProgress } = {}) {
  const safeName =
    file.name
      .toLowerCase()
      .replace(/[^a-z0-9.]+/g, "-")
      .replace(/^-+|-+$/g, "") || "afbeelding";
  const path = `${folder}/${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 8)}-${safeName}`;

  const task = uploadBytesResumable(ref(storage, path), file, {
    contentType: file.type,
    cacheControl: "public, max-age=31536000",
  });

  return new Promise((resolve, reject) => {
    task.on(
      "state_changed",
      (snapshot) => {
        if (onProgress) {
          onProgress(
            Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
          );
        }
      },
      reject,
      () => getDownloadURL(task.snapshot.ref).then(resolve, reject)
    );
  });
}

// Alleen bestanden in onze eigen bucket kunnen we verwijderen; oudere artikelen
// verwijzen soms naar een externe url en die laten we met rust.
export function isStorageUrl(url) {
  return (
    typeof url === "string" &&
    url.startsWith("https://firebasestorage.googleapis.com/")
  );
}

export async function deleteImageByUrl(url) {
  if (!isStorageUrl(url)) {
    return;
  }
  try {
    await deleteObject(ref(storage, url));
  } catch (error) {
    // Het bestand kan al weg zijn (bijv. dubbel opgeslagen); dat is geen probleem.
    if (error.code !== "storage/object-not-found") {
      console.error("Verwijderen van afbeelding mislukt", url, error);
    }
  }
}
